module.exports = __webpack_public_path__ + "static/media/github.acf718bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/homepage/github.png
// module id = 1512
// module chunks = 0